module.exports = __webpack_public_path__ + "static/img/Flush.6b9cd12.svg";